import React from 'react';

const Footer = () => {
  // Using the thumbnail endpoint which is often more reliable for embedding
  const logoUrl = "https://drive.google.com/thumbnail?id=1LoeK4l_vOT55bkYlZryk9a387K5AE9WK&sz=w200";

  return (
    <footer className="bg-slate-900 text-slate-400 py-16">
      <div className="container">
        <div className="text-center">
          <div className="flex items-center justify-center mb-8">
            <img 
              src={logoUrl} 
              alt="Sellers Anonymous Logo" 
              className="h-8 w-auto object-contain brightness-110" 
              referrerPolicy="no-referrer" 
            />
          </div>
          
          <p className="text-slate-400 mb-8 max-w-md mx-auto">
            A community of highly principled, buyer-centric sellers who live by the principles of The Seller Code.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8 mb-12">
            <a 
              href="https://thesellercode.org/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-cyan-400 hover:text-cyan-300 underline underline-offset-4 transition-colors"
            >
              The Seller Code
            </a>
            <a 
              href="mailto:hello@sellersanonymous.com"
              className="text-slate-300 hover:text-white transition-colors"
            >
              Contact Us
            </a>
          </div>

          <div className="pt-8 border-t border-slate-800/50">
            <p className="text-sm text-slate-500">
              © {new Date().getFullYear()} Sellers Anonymous. Built for those who put buyers first.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;